(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[13],{

/***/ "/0+H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.isInAmpMode = isInAmpMode;
exports.useAmp = useAmp;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

var _ampContext = __webpack_require__("lwAK");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function isInAmpMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$ampFirst = _ref.ampFirst,
      ampFirst = _ref$ampFirst === void 0 ? false : _ref$ampFirst,
      _ref$hybrid = _ref.hybrid,
      hybrid = _ref$hybrid === void 0 ? false : _ref$hybrid,
      _ref$hasQuery = _ref.hasQuery,
      hasQuery = _ref$hasQuery === void 0 ? false : _ref$hasQuery;

  return ampFirst || hybrid && hasQuery;
}

function useAmp() {
  // Don't assign the context value to a variable to save bytes
  return isInAmpMode(_react["default"].useContext(_ampContext.AmpStateContext));
}

/***/ }),

/***/ "48fX":
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__("qhzo");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),

/***/ "5fIB":
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__("7eYB");

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;

/***/ }),

/***/ "8Kt/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _defineProperty = __webpack_require__("oI91");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.defaultHead = defaultHead;
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__("q1tI"));

var _sideEffect = _interopRequireDefault(__webpack_require__("Xuae"));

var _ampContext = __webpack_require__("lwAK");

var _headManagerContext = __webpack_require__("FYa8");

var _amp = __webpack_require__("/0+H");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function defaultHead() {
  var inAmpMode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var head = [/*#__PURE__*/_react["default"].createElement("meta", {
    charSet: "utf-8"
  })];

  if (!inAmpMode) {
    head.push( /*#__PURE__*/_react["default"].createElement("meta", {
      name: "viewport",
      content: "width=device-width"
    }));
  }

  return head;
}

function onlyReactElement(list, child) {
  // React children can be "string" or "number" in this case we ignore them for backwards compat
  if (typeof child === 'string' || typeof child === 'number') {
    return list;
  } // Adds support for React.Fragment


  if (child.type === _react["default"].Fragment) {
    return list.concat(_react["default"].Children.toArray(child.props.children).reduce(function (fragmentList, fragmentChild) {
      if (typeof fragmentChild === 'string' || typeof fragmentChild === 'number') {
        return fragmentList;
      }

      return fragmentList.concat(fragmentChild);
    }, []));
  }

  return list.concat(child);
}

var METATYPES = ['name', 'httpEquiv', 'charSet', 'itemProp'];
/*
returns a function for filtering head child elements
which shouldn't be duplicated, like <title/>
Also adds support for deduplicated `key` properties
*/

function unique() {
  var keys = new Set();
  var tags = new Set();
  var metaTypes = new Set();
  var metaCategories = {};
  return function (h) {
    var isUnique = true;

    if (h.key && typeof h.key !== 'number' && h.key.indexOf('$') > 0) {
      var key = h.key.slice(h.key.indexOf('$') + 1);

      if (keys.has(key)) {
        isUnique = false;
      } else {
        keys.add(key);
      }
    } // eslint-disable-next-line default-case


    switch (h.type) {
      case 'title':
      case 'base':
        if (tags.has(h.type)) {
          isUnique = false;
        } else {
          tags.add(h.type);
        }

        break;

      case 'meta':
        for (var i = 0, len = METATYPES.length; i < len; i++) {
          var metatype = METATYPES[i];
          if (!h.props.hasOwnProperty(metatype)) continue;

          if (metatype === 'charSet') {
            if (metaTypes.has(metatype)) {
              isUnique = false;
            } else {
              metaTypes.add(metatype);
            }
          } else {
            var category = h.props[metatype];
            var categories = metaCategories[metatype] || new Set();

            if (categories.has(category)) {
              isUnique = false;
            } else {
              categories.add(category);
              metaCategories[metatype] = categories;
            }
          }
        }

        break;
    }

    return isUnique;
  };
}
/**
*
* @param headElements List of multiple <Head> instances
*/


function reduceComponents(headElements, props) {
  return headElements.reduce(function (list, headElement) {
    var headElementChildren = _react["default"].Children.toArray(headElement.props.children);

    return list.concat(headElementChildren);
  }, []).reduce(onlyReactElement, []).reverse().concat(defaultHead(props.inAmpMode)).filter(unique()).reverse().map(function (c, i) {
    var key = c.key || i;

    if (false) { var newProps; }

    return /*#__PURE__*/_react["default"].cloneElement(c, {
      key: key
    });
  });
}
/**
* This component injects elements to `<head>` of your page.
* To avoid duplicated `tags` in `<head>` you can use the `key` property, which will make sure every tag is only rendered once.
*/


function Head(_ref) {
  var children = _ref.children;
  var ampState = (0, _react.useContext)(_ampContext.AmpStateContext);
  var headManager = (0, _react.useContext)(_headManagerContext.HeadManagerContext);
  return /*#__PURE__*/_react["default"].createElement(_sideEffect["default"], {
    reduceComponentsToState: reduceComponents,
    headManager: headManager,
    inAmpMode: (0, _amp.isInAmpMode)(ampState)
  }, children);
} // TODO: Remove in the next major release


Head.rewind = function () {};

var _default = Head;
exports["default"] = _default;

/***/ }),

/***/ "FYa8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.HeadManagerContext = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var HeadManagerContext = /*#__PURE__*/_react["default"].createContext({});

exports.HeadManagerContext = HeadManagerContext;

if (false) {}

/***/ }),

/***/ "HIAB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _footer_categories__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("V+Py");
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _footer_categories__WEBPACK_IMPORTED_MODULE_0__["a"]; });



/***/ }),

/***/ "T0f4":
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),

/***/ "V+Py":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__("1OyB");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__("vuIU");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__("JX7q");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js + 1 modules
var inherits = __webpack_require__("Ji7U");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js + 1 modules
var possibleConstructorReturn = __webpack_require__("md7G");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__("foSv");

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__("rePB");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__("q1tI");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./node_modules/classnames/bind.js
var bind = __webpack_require__("UbMB");
var bind_default = /*#__PURE__*/__webpack_require__.n(bind);

// EXTERNAL MODULE: ./src/components/desktop/common/footer/footer-categories/styles.module.scss
var styles_module = __webpack_require__("VrER");
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);

// CONCATENATED MODULE: ./src/components/desktop/common/footer/footer-categories/categories.js
var categories_categories = [{
  id: 1,
  name: 'Satılık',
  subCategories: [{
    title: 'Genel',
    children: [{
      name: 'Satılık Daire',
      href: '/satilik-daire'
    }, {
      name: 'Satılık İşyeri',
      href: '/satilik-isyeri'
    }, {
      name: 'Satılık Arsa',
      href: '/satilik-arsa'
    }, {
      name: 'Satılık Turistik Tesis',
      href: '/satilik-turistik-tesis'
    }, {
      name: 'Satılık Konut',
      href: '/satilik-konut'
    }]
  }, {
    title: 'Daire',
    children: [{
      name: 'İstanbul Satılık Daire',
      href: '/satilik-daire/istanbul'
    }, {
      name: 'Ankara Satılık Daire',
      href: '/satilik-daire/ankara'
    }, {
      name: 'İzmir Satılık Daire',
      href: '/satilik-daire/izmir'
    }, {
      name: 'Bursa Satılık Daire',
      href: '/satilik-daire/bursa'
    }, {
      name: 'Antalya Satılık Daire',
      href: '/satilik-daire/antalya'
    }]
  }, {
    title: 'İşyeri',
    children: [{
      name: 'İstanbul Satılık İşyeri',
      href: '/satilik-isyeri/istanbul'
    }, {
      name: 'Ankara Satılık İşyeri',
      href: '/satilik-isyeri/ankara'
    }, {
      name: 'İzmir Satılık İşyeri',
      href: '/satilik-isyeri/izmir'
    }, {
      name: 'Bursa Satılık İşyeri',
      href: '/satilik-isyeri/bursa'
    }, {
      name: 'Antalya Satılık İşyeri',
      href: '/satilik-isyeri/antalya'
    }]
  }, {
    title: 'Arsa',
    children: [{
      name: 'İstanbul Satılık Arsa',
      href: '/satilik-arsa/istanbul'
    }, {
      name: 'Ankara Satılık Arsa',
      href: '/satilik-arsa/ankara'
    }, {
      name: 'İzmir Satılık Arsa',
      href: '/satilik-arsa/izmir'
    }, {
      name: 'Bursa Satılık Arsa',
      href: '/satilik-arsa/bursa'
    }, {
      name: 'Antalya Satılık Arsa',
      href: '/satilik-arsa/antalya'
    }]
  }, {
    title: 'Konut Projeleri',
    children: [{
      name: 'Ankara Konut Projeleri',
      href: '/satilik-konut/ankara/projeler'
    }, {
      name: 'İstanbul Konut Projeleri',
      href: '/satilik-konut/istanbul/projeler'
    }, {
      name: 'İzmir Konut Projeleri',
      href: '/satilik-konut/izmir/projeler'
    }, {
      name: 'Antalya Konut Projeleri',
      href: '/satilik-konut/antalya/projeler'
    }, {
      name: 'Bursa Konut Projeleri',
      href: '/satilik-konut/bursa/projeler'
    }]
  }]
}, {
  id: 2,
  name: 'Kiralık',
  subCategories: [{
    title: 'Genel',
    children: [{
      name: 'Kiralık Daire',
      href: '/kiralik-daire'
    }, {
      name: 'Kiralık İşyeri',
      href: '/kiralik-isyeri'
    }, {
      name: 'Kiralık Arsa',
      href: '/kiralik-arsa'
    }, {
      name: 'Kiralık Turistik Tesis',
      href: '/kiralik-turistik-tesis'
    }, {
      name: 'Kiralık Konut',
      href: '/kiralik-konut'
    }]
  }, {
    title: 'Daire',
    children: [{
      name: 'İstanbul Kiralık Daire',
      href: '/kiralik-daire/istanbul'
    }, {
      name: 'Ankara Kiralık Daire',
      href: '/kiralik-daire/ankara'
    }, {
      name: 'İzmir Kiralık Daire',
      href: '/kiralik-daire/izmir'
    }, {
      name: 'Bursa Kiralık Daire',
      href: '/kiralik-daire/bursa'
    }, {
      name: 'Antalya Kiralık Daire',
      href: '/kiralik-daire/antalya'
    }]
  }, {
    title: 'İşyeri',
    children: [{
      name: 'İstanbul Kiralık İşyeri',
      href: '/kiralik-isyeri/istanbul'
    }, {
      name: 'Ankara Kiralık İşyeri',
      href: '/kiralik-isyeri/ankara'
    }, {
      name: 'İzmir Kiralık İşyeri',
      href: '/kiralik-isyeri/izmir'
    }, {
      name: 'Bursa Kiralık İşyeri',
      href: '/kiralik-isyeri/bursa'
    }, {
      name: 'Antalya Kiralık İşyeri',
      href: '/kiralik-isyeri/antalya'
    }]
  }, {
    title: 'Arsa',
    children: [{
      name: 'İstanbul Kiralık Arsa',
      href: '/kiralik-arsa/istanbul'
    }, {
      name: 'Ankara Kiralık Arsa',
      href: '/kiralik-arsa/ankara'
    }, {
      name: 'İzmir Kiralık Arsa',
      href: '/kiralik-arsa/izmir'
    }, {
      name: 'Bursa Kiralık Arsa',
      href: '/kiralik-arsa/bursa'
    }, {
      name: 'Antalya Kiralık Arsa',
      href: '/kiralik-arsa/antalya'
    }]
  }, {
    title: 'Günlük Kiralık',
    children: [{
      name: 'İstanbul Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/istanbul'
    }, {
      name: 'Ankara Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/ankara'
    }, {
      name: 'İzmir Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/izmir'
    }, {
      name: 'Antalya Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/antalya'
    }, {
      name: 'Mersin Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/mersin'
    }]
  }]
}, {
  id: 3,
  name: 'Sahibinden',
  subCategories: [{
    title: 'Genel',
    children: [{
      name: 'Sahibinden Satılık Daire',
      href: '/satilik-daire/sahibinden'
    }, {
      name: 'Sahibinden Satılık İşyeri',
      href: '/satilik-isyeri/sahibinden'
    }, {
      name: 'Sahibinden Satılık Arsa',
      href: '/satilik-arsa/sahibinden'
    }, {
      name: 'Sahibinden Satılık Turistik Tesis',
      href: '/satilik-turistik-tesis/sahibinden'
    }, {
      name: 'Sahibinden Satılık Konut',
      href: '/satilik-konut/sahibinden'
    }]
  }, {
    title: 'Daire',
    children: [{
      name: 'Sahibinden İstanbul Satılık Daire',
      href: '/satilik-daire/istanbul/sahibinden'
    }, {
      name: 'Sahibinden Ankara Satılık Daire',
      href: '/satilik-daire/ankara/sahibinden'
    }, {
      name: 'Sahibinden İzmir Satılık Daire',
      href: '/satilik-daire/izmir/sahibinden'
    }, {
      name: 'Sahibinden Bursa Satılık Daire',
      href: '/satilik-daire/bursa/sahibinden'
    }, {
      name: 'Sahibinden Antalya Satılık Daire',
      href: '/satilik-daire/antalya/sahibinden'
    }]
  }, {
    title: 'İşyeri',
    children: [{
      name: 'Sahibinden İstanbul Satılık İşyeri',
      href: '/satilik-isyeri/istanbul/sahibinden'
    }, {
      name: 'Sahibinden Ankara Satılık İşyeri',
      href: '/satilik-isyeri/ankara/sahibinden'
    }, {
      name: 'Sahibinden İzmir Satılık İşyeri',
      href: '/satilik-isyeri/izmir/sahibinden'
    }, {
      name: 'Sahibinden Bursa Satılık İşyeri',
      href: '/satilik-isyeri/bursa/sahibinden'
    }, {
      name: 'Sahibinden Antalya Satılık İşyeri',
      href: '/satilik-isyeri/antalya/sahibinden'
    }]
  }, {
    title: 'Arsa',
    children: [{
      name: 'Sahibinden İstanbul Satılık Arsa',
      href: '/satilik-arsa/istanbul/sahibinden'
    }, {
      name: 'Sahibinden Ankara Satılık Arsa',
      href: '/satilik-arsa/ankara/sahibinden'
    }, {
      name: 'Sahibinden İzmir Satılık Arsa',
      href: '/satilik-arsa/izmir/sahibinden'
    }, {
      name: 'Sahibinden Bursa Satılık Arsa',
      href: '/satilik-arsa/bursa/sahibinden'
    }, {
      name: 'Sahibinden Antalya Satılık Arsa',
      href: '/satilik-arsa/antalya/sahibinden'
    }]
  }, {
    title: 'Villa',
    children: [{
      name: 'Sahibinden Antalya Satılık Villa',
      href: '/satilik-villa/antalya/sahibinden'
    }, {
      name: 'Sahibinden İstanbul Satılık Villa',
      href: '/satilik-villa/istanbul/sahibinden'
    }, {
      name: 'Sahibinden Muğla Satılık Villa',
      href: '/satilik-villa/mugla/sahibinden'
    }, {
      name: 'Sahibinden İzmir Satılık Villa',
      href: '/satilik-villa/izmir/sahibinden'
    }, {
      name: 'Sahibinden Ankara Satılık Villa',
      href: '/satilik-villa/ankara/sahibinden'
    }]
  }]
}, {
  id: 4,
  name: 'Popüler',
  subCategories: [{
    children: [{
      name: 'Antalya Kiralık Daire',
      href: '/kiralik-daire/antalya'
    }, {
      name: 'Eskişehir Kiralık Daire',
      href: '/kiralik-daire/eskisehir'
    }, {
      name: 'Diyarbakır Kiralık Daire',
      href: '/kiralik-daire/diyarbakir'
    }, {
      name: 'Gaziantep Kiralık Daire',
      href: '/kiralik-daire/gaziantep'
    }, {
      name: 'Malatya Kiralık Daire',
      href: '/kiralik-daire/malatya'
    }, {
      name: 'Konya Kiralık Daire',
      href: '/kiralik-daire/konya'
    }]
  }, {
    children: [{
      name: 'Kiralık Villa',
      href: '/kiralik-villa'
    }, {
      name: 'Antalya Kiralık Villa',
      href: '/kiralik-villa/antalya'
    }, {
      name: 'Bodrum Kiralık Villa',
      href: '/kiralik-villa/mugla-bodrum'
    }, {
      name: 'Fethiye Kiralık Villa',
      href: '/kiralik-villa/mugla-fethiye'
    }, {
      name: 'Kaş Kiralık Villa',
      href: '/kiralik-villa/antalya-kas'
    }, {
      name: 'Mersin Kiralık Villa',
      href: '/kiralik-villa/mersin'
    }]
  }, {
    children: [{
      name: 'Satılık Villa',
      href: '/satilik-villa'
    }, {
      name: 'Kuşadası Satılık Villa',
      href: '/satilik-villa/aydin-kusadasi'
    }, {
      name: 'İzmir Satılık Villa',
      href: '/satilik-villa/izmir'
    }, {
      name: 'Muğla Satılık Villa',
      href: '/satilik-villa/mugla'
    }, {
      name: 'Ankara Satılık Villa',
      href: '/satilik-villa/ankara'
    }, {
      name: 'Urla Satılık Villa',
      href: '/satilik-villa/izmir-urla'
    }]
  }, {
    children: [{
      name: 'Gaziantep Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/gaziantep'
    }, {
      name: 'Bursa Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/bursa'
    }, {
      name: 'Samsun Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/samsun'
    }, {
      name: 'Adana Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/adana'
    }, {
      name: 'Eskişehir Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/eskisehir'
    }, {
      name: 'Balıkesir Günlük Kiralık Daire',
      href: '/gunluk-kiralik-konut/balikesir'
    }]
  }, {
    children: [{
      name: 'Tekirdağ Satılık Arsa',
      href: '/satilik-arsa/tekirdag'
    }, {
      name: 'Balıkesir Satılık Arsa',
      href: '/satilik-arsa/balikesir'
    }, {
      name: 'Çanakkale Satılık Arsa',
      href: '/satilik-arsa/canakkale'
    }, {
      name: 'Kırklareli Satılık Arsa',
      href: '/satilik-arsa/kirklareli'
    }, {
      name: 'Sakarya Satılık Arsa',
      href: '/satilik-arsa/sakarya'
    }, {
      name: 'Kütahya Satılık Arsa',
      href: '/satilik-arsa/kutahya'
    }]
  }]
}];
/* harmony default export */ var footer_categories_categories = (categories_categories);
// CONCATENATED MODULE: ./src/components/desktop/common/footer/footer-categories/footer-categories.jsx







var __jsx = react_default.a.createElement;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = Object(getPrototypeOf["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = Object(getPrototypeOf["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return Object(possibleConstructorReturn["a" /* default */])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }






var footer_categories_FooterList = /*#__PURE__*/function (_PureComponent) {
  Object(inherits["a" /* default */])(FooterList, _PureComponent);

  var _super = _createSuper(FooterList);

  function FooterList() {
    var _this;

    Object(classCallCheck["a" /* default */])(this, FooterList);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "state", {
      active: 1
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "renderSubCategoriesItem", function (children) {
      return children.map(function (child) {
        return __jsx("a", {
          key: child.name,
          href: child.href
        }, child.name);
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "renderSubCategories", function () {
      var active = _this.state.active;
      var filterCategory = footer_categories_categories.filter(function (item) {
        return item.id === active;
      });
      var _filterCategory$ = filterCategory[0],
          subCategories = _filterCategory$.subCategories,
          name = _filterCategory$.name;
      return subCategories.map(function (categories, index) {
        return __jsx("div", {
          key: categories.title,
          className: styles_module_default.a.categoriesSubCategories
        }, name !== 'Popüler' && __jsx("div", null, categories.title), _this.renderSubCategoriesItem(categories.children));
      });
    });

    Object(defineProperty["default"])(Object(assertThisInitialized["a" /* default */])(_this), "renderItem", function () {
      var active = _this.state.active;
      return footer_categories_categories.map(function (item) {
        var itemClassname = bind_default()(Object(defineProperty["default"])({}, styles_module_default.a.active, item.id === active));
        return __jsx("a", {
          key: item.id,
          className: itemClassname,
          onClick: _this.onChange.bind(Object(assertThisInitialized["a" /* default */])(_this), item.id)
        }, item.name);
      });
    });

    return _this;
  }

  Object(createClass["a" /* default */])(FooterList, [{
    key: "onChange",
    value: function onChange(id) {
      this.setState({
        active: id
      });
    }
  }, {
    key: "render",
    value: function render() {
      return __jsx("div", {
        className: styles_module_default.a.categoriesMain
      }, __jsx("div", {
        className: styles_module_default.a.categoriesContent
      }, __jsx("div", {
        className: styles_module_default.a.categoriesMenu
      }, this.renderItem()), __jsx("div", {
        className: styles_module_default.a.categoriesSubContent
      }, this.renderSubCategories())));
    }
  }]);

  return FooterList;
}(react["PureComponent"]);

/* harmony default export */ var footer_categories = __webpack_exports__["a"] = (footer_categories_FooterList);

/***/ }),

/***/ "VrER":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin
module.exports = {"categoriesMain":"_2sabUq","categoriesContent":"_3RygVw","categoriesMenu":"_32AGB9","active":"_1H6q1P","categoriesSubContent":"yBJ2ae","categoriesSubCategories":"_6Bx8pw"};

/***/ }),

/***/ "Xuae":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _toConsumableArray = __webpack_require__("mPvQ");

var _classCallCheck = __webpack_require__("/GRZ");

var _createClass = __webpack_require__("i2R6");

var _assertThisInitialized = __webpack_require__("qXWd");

var _inherits = __webpack_require__("48fX");

var _possibleConstructorReturn = __webpack_require__("tCBg");

var _getPrototypeOf = __webpack_require__("T0f4");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

exports.__esModule = true;
exports["default"] = void 0;

var _react = __webpack_require__("q1tI");

var isServer = false;

var _default = /*#__PURE__*/function (_react$Component) {
  _inherits(_default, _react$Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    _classCallCheck(this, _default);

    _this = _super.call(this, props);
    _this._hasHeadManager = void 0;

    _this.emitChange = function () {
      if (_this._hasHeadManager) {
        _this.props.headManager.updateHead(_this.props.reduceComponentsToState(_toConsumableArray(_this.props.headManager.mountedInstances), _this.props));
      }
    };

    _this._hasHeadManager = _this.props.headManager && _this.props.headManager.mountedInstances;

    if (isServer && _this._hasHeadManager) {
      _this.props.headManager.mountedInstances.add(_assertThisInitialized(_this));

      _this.emitChange();
    }

    return _this;
  }

  _createClass(_default, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances.add(this);
      }

      this.emitChange();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.emitChange();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this._hasHeadManager) {
        this.props.headManager.mountedInstances["delete"](this);
      }

      this.emitChange();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return _default;
}(_react.Component);

exports["default"] = _default;

/***/ }),

/***/ "g4pe":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("8Kt/")


/***/ }),

/***/ "kG2m":
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;

/***/ }),

/***/ "lwAK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.AmpStateContext = void 0;

var _react = _interopRequireDefault(__webpack_require__("q1tI"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AmpStateContext = /*#__PURE__*/_react["default"].createContext({});

exports.AmpStateContext = AmpStateContext;

if (false) {}

/***/ }),

/***/ "mPvQ":
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__("5fIB");

var iterableToArray = __webpack_require__("rlHP");

var unsupportedIterableToArray = __webpack_require__("KckH");

var nonIterableSpread = __webpack_require__("kG2m");

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;

/***/ }),

/***/ "oI91":
/***/ (function(module, exports) {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;

/***/ }),

/***/ "qXWd":
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),

/***/ "rlHP":
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

module.exports = _iterableToArray;

/***/ }),

/***/ "tCBg":
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__("C+bE");

var assertThisInitialized = __webpack_require__("qXWd");

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ })

}]);